export default {
  // Посчитаем?
  calculate_title: 'Есептейік?',
  gold_content: 'Алтын сынамасы:',
  gold_weight_grams: 'Алтын салмағы, грамм:',
  gold_weight_exceed: 'Алтын салмағы',
  gram_text: 'граммнан аспауы керек',
  gram: 'грамм',
  loan_term_days: 'Микрокредит мерзімі, күндер:',
  loan_term_exceed: 'Қарыз мерзімі',
  days_text: 'күннен аспауы керек',
  days: 'күн',
  amount_on_hand: 'Қолға берілетін сома:',
  refund_amount: 'Қайтарылатын сома:',
  // Экспресс-продление
  expressExtension: 'Экспресс-төлем',
  iin: 'ЖСН',
  enter_iin: 'ЖСН Енгізіңіз',
  number_zb: 'Кепілзаттық билетінің нөмірі',
  enter_zb: 'Кепілзаттық билетінің нөмірін енгізіңіз',
  extent_loan: 'Микрокредитті ұзарту',
  express_text1: 'Кез келген уақытта сіз өзіңіздің жеке <br>  кабинетiңiзде несиені ұзарта аласыз, <br> сонымен қатар барлық несиелер <br> туралы толық ақпарат ала аласыз.',
  something_went_wrong: 'Дұрыс болмады',
  express_text2: 'ЖСН немесе кепiлзат билетінiң нөмірі <br> дұрыс емес, қайта енгiзiңiз.',
  service_unavailable: 'Қызмет уақытша жұмыс істемейді. Кейінірек қайталап көріңіз.',
  enter_term: 'немесе мерзімді қолмен енгізіңіз',
  total_payment: 'Барлығы:',
  pay: 'Төлеу',
  express_text3: 'Бұл жерде қате пайда болған сияқты. <br> Мүмкін тағы бір рет?',
  loan_successfully_extended: 'Қарыз мерзiмi сәтті ұзартылды',
  super: 'Керемет!',
  view_receipt: 'Түбіртекті қарау',
  tg: 'тг',
    // Загляни к нам
  office_radius: 'Сізге ең жақын офис мына радиуста',
  km: 'км',
  all: 'Барлық',
  are_you_here: 'Сен осы жердесiң',
  // Пообщаемся?
  contact_you: 'Сенің атың кім?',
  nickname_yourself: 'Өзіңе лақап ат ал',
  nickname: 'Мадонна Луиза Вероника Чикконе',
  call_you: 'Саған қайда қоңырау шалу керек?',
  write_me: 'Маған жазсайшы',
  message_text: 'Хабар мәтіні',
  send: 'Жіберу',
  modal_error1: 'Атты толтырыңыз немесе атау генераторын пайдаланыңыз.',
  modal_error2: 'Нөмір дұрыс емес сияқты.. Қате нөмір енгізілді.',
  modal_error3: 'Электрондық поштаны және байланыс нөмірін енгізіңіз.',
  modal_error3_1: 'Электрондық поштаны енгізіңіз.',
  modal_error4: 'Электрондық пошта қате енгізілді.',
  modal_error5: 'Электрондық поштаны енгізген кезде хабарламаның мәтінін толтыру қажет.',
  modal_error6: 'Байланыста боламыз! Жақын арада қоңырау шаламыз!',
  // title
  rules_title: 'Ережесіз болмайды!',
  online_rules_title: 'Online операциялар ережелері',
  location_title: 'Бізге кел',
    form_title: 'Тілдесеміз бе?',
  qa_title: 'Жиі қойылатын сұрақтар',
  // admin
  to_come_in: 'Кіру',
  registration: 'Тіркелу',
  personal_cabinet: 'Жеке кабинет',
  password: 'Құпия сөз',
  enter_password: 'Құпия сөзді енгізіңіз',
  login: 'Кіру',
  number_phone: 'Телефон нөмірі',
  forgot_password: 'Құпия сөзді ұмыттыңыз ба?',
  signup: 'Тіркелу',
  login_a: 'Авторизация',
  check_in: 'Тіркелу',
  code: 'Код алу',
  sms_code: 'СМС код',
  further: 'Келесі',
  fpassword_text: 'Сіз кодты қайтадан',
  seconds: 'секунд ішінде <br> жібере аласыз',
  send_code_again: 'Кодты қайтадан жіберу',
  new_password: 'Жаңа құпия сөз',
  repeat_new_password: 'Жаңа құпия сөзді қайталаңыз',
  enter_new_password: 'Жаңа құпия сөзді енгізіңіз',
  enter_repeat_new_password: 'Жаңа құпия сөзді қайталап енгізіңіз',
  save: 'Сақтау',
  ent_password:'Құпия сөзді енгізіңіз',
  ent_your_password: 'Құпия сөзді енгізіңіз',
  rep_password:'Құпия сөзді қайталаңыз',
  re_enter_your_password:'Құпия сөзді қайталап енгізіңіз',
  back: 'Артқа',
  // админ меню
  my_loans: 'Менің қарыздарым',
  express_renewal: 'Жылдам төлем',
  my_last_operations: 'Менің соңғы операцияларым',
  valuation_capital: 'Менің капиталымды бағалау',
  notification_history: 'Хабарламаның тарихы',
  change_details: 'Жеке деректерді өзгерту',
  change_password: 'Құпия сөзді өзгерту',
  exit: 'Шығу',
// Мои займы
  security_ticket: 'Кепілзаттық билет',
  guaranteed_time_green: 'Қарыз мерзімі',
  guaranteed_time_yellow: 'Кепілді күту кезеңі',
  guaranteed_time_orange: 'Кепілдік күту кезеңі аяқталуда',
  guaranteed_time_red: 'Кепілді күту кезеңі аяқталды',
  loan_balance: 'Несиенің қалған сомасы',
  on_loan: 'Қарыздың %',
  for_delay:'Кешіктірілу %',
  interest_payable: 'Төленетін пайыз',
  in_detail: 'Толық оқу',
  pay_for_renewal:'Ұзарту мерзімінің ақысы',
  for_partial_repayment:'Ішінара төлем ақысы',
  change_operation_parameters: 'Операция параметрлерін өзгерту',
  hide: 'Жасыру',
  partial_repayment: 'Ішінара төлем үшін',
  renewal: 'Үзарту қызметтері ушін',
  new_loan_term:'Несиенің жаңа мерзімі:',
  remuneration_amount: 'Сыйақының сомасы:',
  partial_redemption_amount: 'Ішінара өтеу сомасы, <br> төлеу:',
  from: 'бастап',
  before: 'дейін',
  balance_loan_amount: 'Қалған қарыз сомасы <br> төлемнен кейін',
  to_apply: 'Қолдану',
  how_many_days: 'Қанша күн төлеймін:',
  new_term:'Жаңа мерзім:',
  pay_loan_extension: 'Ұзарту мерзімінің ақысы:',
  pay_loan_partial_repayment: 'Ішінара төлем ақысы',
  branch: 'Бөлімше',
  loan_term: 'Қарыз мерзімі',
  guaranteed_term: 'Кепілдік мерзімі',
  which_loan: 'оның ішінде: қарыздың %',
  total_return:'Барлығы',
  name: 'Бұйым атауы',
  description: 'Сипаттамасы',
  edit: 'Өңдеу',
  product_description: 'Бұйымнің сипаттамасы',
  products: 'Бұйым',
  probe: 'Сынама',
  weight: 'Салмақ, гр',
  content: 'Құрамы',
  gr: 'гр',
  pay_total: 'Төлеу',
  add_description: 'Сипаттамасын қосу',
    // Мои последние операции
  order_number: 'Тапсырыс нөмірі',
  date_and_time: 'Күні мен уақыты',
  place_operation: 'Жұмыс орны',
  operation: 'Операция',
  transaction_amount: 'Операция сомасы',
  status: 'Күйі',
  receipt: 'Түбіртек',
  total_amount: 'Қорытынды сома',
  held: 'Өткізілді',
  canceled: 'Өткізілмеді',
  text_operation: 'Мұнда кепілзаттық билеттері бойынша операциялар көрсетіледі',
  // Оценка моего капитала
  title_o: 'Атауы',
  img: 'Суреті',
  product_weight:'Бұйым салмағы',
  getting_hands:'Қолға <br> алатын сома',
  add_item:'Бұйымды қосу',
  total:'Барлығы',
  add_item_2:'Бұйымды қосу',
  product_name:'Бұйым атауы',
  product_your_name:'Бұйым атауы',
  add: 'Қосу',
  today: 'Бүгін',
  text_1: 'мен бұрын сатып алған бұйымдарым үшін MK-Золото-дан',
  text_2: 'ала аламын',
    // Изменить мои данные
  fio: 'Аты-жөні',
  date_birth:'Туған күні',
  text_3: 'Жеке мәліметтерді өзгерту үшін филиалға барып, <br> жеке куәлік көрсету қажет',
  change:'Өзгерту',
  new_phone:'Жаңа байланыс нөмері',
  complete:'Аяқтау',
  your_number_changed:'Сіздің нөмеріңіз өзгертілді',
  new_e_mail_address:'Жаңа e-mail адресі',
  your_mail_changed:'Сіздің почтаңыз өзгертілді',
  // Изменить мой пароль
  current_password:'Ағымдағы құпия сөз',
  enter_current_password:'Ағымдағы құпия сөзді енгізіңіз',
  enter_new_password1:'Жаңа құпия сөзді енгізіңіз',
  new_password_again:'Жаңа құпия сөзді қайта енгізу',
  re_enter_new_password:'Жаңа құпия сөзді қайта енгізіңіз',
  password_error:'Құпия сөз және қайта құпия сөз сәйкес келмейді',
    // Смена аватарки
  mbErrorText: 'Cурет өлшемі 10 мб аспауы керек',
  avatar_change: 'Аватарды өзгерту',
  upload_image: 'Суретті жүктеу',
  take_avatars:'Біздің аватарымызды алыңыз',
  text_zd: 'Мұнда кепілзаттық билеттері көрсетіледі',
    // договор
  check_contract: 'Келісім-шарт тексеру',
  check_contract2: 'Сіздің келісім-шартыңыз',
  check_contract3: 'Сіздің электрондық келісім-шартыңыз',
  contract_code: 'Код',
  contract_text: 'Код компанияның кеңсесінде қағаз түрінде беріледі',
  enter_contract_code: 'Кодты еңгізіңіз',
  verify: 'Алу',
  confirmation: 'Растау',
  contract_text2: 'Келісім шарттарымен және кепілдемемен',
  read_and_agree: 'Таныстым және келістім',
  conservation_receipt: 'Сақталған түбіртек',
  shelf_life: 'Сақтау мерзімі',
  keep_price: 'Сақтау ақысы',
  loan_expired: 'Мерзімі бітті',
  message_text_loan: 'Назар аударыңыз! <br> Таңдалған несие үшін кез-келген филиалда сақтау туралы келісім жасау керек.',
  login_t: 'Логин',
  login_placeholder: 'Логиніңізді енгізіңіз',
  login_text: 'Логин мен Код компанияның кеңсесінде қағаз тасымалдағышта беріледі',
  message_no_text: 'Операцияны жалғастыру мүмкін емес. <br> Филиалға хабарласуыңызды сұраймыз',
}












// WEBPACK FOOTER //
// ./src/lang/kz.js